import { render, staticRenderFns } from "./centralizedPurchaseTable.vue?vue&type=template&id=9f34acec&scoped=true"
import script from "./centralizedPurchaseTable.vue?vue&type=script&lang=js"
export * from "./centralizedPurchaseTable.vue?vue&type=script&lang=js"
import style0 from "./centralizedPurchaseTable.vue?vue&type=style&index=0&id=9f34acec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f34acec",
  null
  
)

export default component.exports